export const BASE_URL = `https://api.bergregions.pl`;
export const STATIONS = `/api/v1/ski-info/45904333/stations`;
